<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("pacom.masterAccount", 2) }}</label>
        <v-select
          label="username"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="masterAccountFilter"
          :options="masterAccounts"
          class="w-100"
          multiple
          :reduce="(val) => val.id"
          @input="(val) => $emit('update:masterAccountFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("pacom.sites", 2) }}</label>
        <v-select
          label="name"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="siteFilter"
          :options="sites"
          class="w-100"
          multiple
          :reduce="(val) => val.id"
          @input="(val) => $emit('update:siteFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    masterAccounts: {
      type: Array,
      default: [],
    },
    masterAccountFilter: {
      default: null
    },
    sites: {
      type: Array,
      default: []
    },
    siteFilter: {
      default: null
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    }
  }
};
</script>
